/* Host HQ by Staysmith: portal app. Renders into #hq-app. */
(function(){
  const root = document.getElementById("hq-app");
  if(!root || !window.HQ_DATA) return;
  const D = window.HQ_DATA;
  const params = new URLSearchParams(location.search);
  const CLEANER = root.dataset.mode === "cleaner" || location.hash === "#cleaner";

  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  const store = {
    get(k,d){ try{ const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; }catch(e){ return d; } },
    set(k,v){ try{ localStorage.setItem(k, JSON.stringify(v)); }catch(e){} }
  };
  const ICON = {
    copy:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M4 16V6a2 2 0 0 1 2-2h10"/></svg>',
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="m5 12 5 5 9-10"/></svg>',
    clock:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    cam:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>',
    chev:'<svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>',
    key:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color:var(--pine-ink)"><circle cx="8" cy="15" r="4"/><path d="M10.8 12.2 19 4"/><path d="m16 7 2.5 2.5"/><path d="m14 9 2 2"/></svg>'
  };
  let toastT;
  function toast(msg){ const t=$("#hq-toast"); t.textContent=msg; t.classList.add("show"); clearTimeout(toastT); toastT=setTimeout(()=>t.classList.remove("show"),1900); }
  function copyText(text, btn, label){
    const done = () => {
      if(btn){ const old = btn.innerHTML; btn.classList.add("done"); btn.innerHTML = ICON.check + "<span>Copied</span>";
        setTimeout(()=>{ btn.classList.remove("done"); btn.innerHTML = old; }, 1600); }
      toast(label || "Copied. Paste it into your message thread.");
    };
    const fallback = () => {
      const ta = document.createElement("textarea"); ta.value = text; ta.setAttribute("readonly","");
      ta.style.position="fixed"; ta.style.opacity="0"; document.body.appendChild(ta); ta.select();
      let ok=false; try{ ok = document.execCommand("copy"); }catch(e){}
      document.body.removeChild(ta);
      ok ? done() : toast("Select the text and copy it manually.");
    };
    if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(text).then(done, fallback); } else fallback();
  }

  const FIELDS = [
    ["property","Listing name","e.g. Cedar Ridge Cabin",false],
    ["host","Your first name","e.g. Jamie",false],
    ["address","Address","Street, city, state, ZIP",true],
    ["checkin","Check-in time","e.g. 4:00 PM",false],
    ["checkout","Checkout time","e.g. 10:00 AM",false],
    ["entry","How guests get in","e.g. the keypad on the front door",true],
    ["wifi","Wi-Fi network","",false],
    ["wifipass","Wi-Fi password","",false],
    ["parking","Parking","e.g. two spots in the driveway",true],
    ["quiet","Quiet hours start","e.g. 10:00 PM",true]
  ];
  const SAMPLE = {id:"sample", property:"Cedar Ridge Cabin", host:"Jamie", address:"418 Pine Hollow Rd, Gatlinburg, TN 37738",
    checkin:"4:00 PM", checkout:"10:00 AM", entry:"the keypad on the front door", wifi:"CedarRidge-Guest", wifipass:"pinecone4418",
    parking:"two spots in the gravel driveway (please don't park on the road)", quiet:"10:00 PM"};
  const MAX_PROPS = 5;
  let props = store.get("hqp_props", {list:[], active:null});
  if(!props || !Array.isArray(props.list)) props = {list:[], active:null};
  const isSample = () => props.list.length === 0;
  const activeProp = () => props.list.find(p => p.id === props.active) || props.list[0] || SAMPLE;
  let P = activeProp();
  function saveProps(){ store.set("hqp_props", props); P = activeProp(); }

  function cleanerLink(){
    let base = root.dataset.cleanerUrl || (location.origin + location.pathname + location.search + "#cleaner");
    try{
      const u = new URL(base, location.href);
      u.searchParams.set("p", P.property || "");
      return u.toString();
    }catch(e){ return base; }
  }
  const val = k => k === "cleanerlink" ? cleanerLink() : (P[k] || "");
  const fillText = t => t.replace(/\{(\w+)\}/g, (m,k) => val(k) || ("[" + k + "]"));
  const fillHTML = t => esc(t)
    .replace(/\{(\w+)\}/g, (m,k) => val(k) ? '<span class="v">' + esc(val(k)) + '</span>' : '<span class="ph">[' + k + ']</span>')
    .replace(/\[([^\]]+)\]/g, '<span class="ph">[$1]</span>');

  const TABS = [["start","Start here"],["messages","Messages"],["playbooks","Playbooks"],["cleaner","Cleaner kit"],["reviews","Reviews"],["prompts","Listing prompts"],["properties","My properties"]];
  if(CLEANER) document.body.classList.add("mode-cleaner");
  const cleanerProp = params.get("p") || "";
  root.innerHTML = `
  <header class="top"><div class="wrap">
    <div class="brand">
      <div class="brand-mark"><div class="key" aria-hidden="true">${ICON.key}</div>
        <div>${CLEANER ? `<h1>Turnover checklist</h1><small>${esc(cleanerProp || "Host HQ by Staysmith")}</small>` : `<h1>Host HQ</h1><small>by Staysmith</small>`}</div></div>
      ${CLEANER ? "" : `<div class="brand-right"><select class="prop-select" id="propSelect" aria-label="Active property"></select></div>`}
    </div>
    ${CLEANER ? "" : `<nav class="tabs" role="tablist" aria-label="Sections">${TABS.map(([v,l]) => `<button class="tab" role="tab" id="tab-${v}" data-view="${v}" aria-selected="false">${l}</button>`).join("")}</nav>`}
  </div></header>
  <main class="wrap" id="hq-main">
    ${CLEANER ? "" : `
    <section class="view" id="view-start" hidden></section>
    <section class="view" id="view-messages" hidden>
      <div class="lede"><h2>Every guest message, already written.</h2><p>Your property details fill in automatically. Fill the highlighted brackets, tap Copy, and paste into Airbnb, VRBO or a text.</p></div>
      <div class="sample-note" id="sampleNote" hidden><span class="dot"></span><div>You're viewing a sample property. <button type="button" data-goto="properties">Add your property details</button> and every message updates.</div></div>
      <input class="search" id="search" type="search" placeholder="Search: early check-in, refund, review…" aria-label="Search messages">
      <div class="chips" id="chips"></div>
      <div class="legend"><span><span class="v">Pine text</span> = your property details</span><span><span class="ph">[Brackets]</span> = fill for this guest</span></div>
      <div class="list" id="msgList"></div>
    </section>
    <section class="view" id="view-playbooks" hidden>
      <div class="lede"><h2>When something breaks mid-stay.</h2><p>Twelve step-by-step plans with a time target for each step. Times count from the moment the guest reports the problem.</p></div>
      <div class="list" id="pbList"></div>
    </section>`}
    <section class="view" id="view-cleaner" ${CLEANER ? "" : "hidden"}></section>
    ${CLEANER ? "" : `
    <section class="view" id="view-reviews" hidden></section>
    <section class="view" id="view-prompts" hidden></section>
    <section class="view" id="view-properties" hidden></section>`}
    <div class="footer-note">Host HQ by Staysmith · Questions? support@staysmithco.com</div>
  </main>
  <div class="toast" id="hq-toast" role="status" aria-live="polite"></div>`;

  const VIEWS = TABS.map(t => t[0]);
  function show(view){
    if(CLEANER) return;
    if(!VIEWS.includes(view)) view = "messages";
    VIEWS.forEach(v => {
      const sec = $("#view-"+v); if(sec) sec.hidden = v !== view;
      const tab = $("#tab-"+v); if(tab) tab.setAttribute("aria-selected", v === view ? "true" : "false");
    });
    const tab = $("#tab-"+view); if(tab && tab.scrollIntoView) tab.scrollIntoView({block:"nearest", inline:"nearest"});
    window.scrollTo(0,0);
    if(history.replaceState) history.replaceState(null, "", "#" + view);
  }
  if(!CLEANER){
    $$(".tab").forEach(b => b.addEventListener("click", () => show(b.dataset.view)));
    document.addEventListener("click", e => { const g = e.target.closest("[data-goto]"); if(g){ e.preventDefault(); show(g.dataset.goto); } });
  }

  function renderSelect(){
    const sel = $("#propSelect"); if(!sel) return;
    if(isSample()){ sel.innerHTML = `<option value="sample">Sample property</option><option value="__add">+ Add your property</option>`; sel.value = "sample"; }
    else{
      sel.innerHTML = props.list.map(p => `<option value="${esc(p.id)}">${esc(p.property || "Untitled property")}</option>`).join("")
        + (props.list.length < MAX_PROPS ? `<option value="__add">+ Add property</option>` : "");
      sel.value = P.id;
    }
  }
  function onSelect(e){
    const v = e.target.value;
    if(v === "__add"){ renderSelect(); show("properties"); openForm(null); return; }
    if(v === "sample") return;
    props.active = v; saveProps(); refreshAll(); toast("Now using " + (P.property || "this property") + ".");
  }

  const FILES = [
    {k:"sheetTcc", fmt:"Google Sheets", name:"Turnover Command Center", d:"Booking-to-clean tracker, cleaner roster with backups, linen par levels, restock list."},
    {k:"sheetNumbers", fmt:"Google Sheets", name:"Host Numbers Dashboard", d:"Cost per stay, cleaning-fee check and profit per listing. For tracking only, not tax advice."},
    {k:"canvaBook", fmt:"Canva", name:"Welcome Book & House Manual", d:"An editable guest guide you brand with your own photos and details."}
  ];
  const fileLink = k => (root.dataset[k] || "").trim();
  const SETUP = [
    {id:"save", t:"Save this page", m:"1 min", html:`<p>Bookmark this page, or on your phone tap Share, then Add to Home Screen. This link is private to you; send your cleaner their own checklist link instead (step 3).</p>`},
    {id:"prop", t:"Add your property details", m:"5 min", html:`<p>Listing name, check-in and checkout times, entry, Wi-Fi, parking and quiet hours. Every message fills them in. Have several listings? Add up to ${MAX_PROPS} and switch at the top.</p><div class="btn-row"><button class="copy" type="button" data-goto="properties">Add my property</button></div>`},
    {id:"cleaner", t:"Send your cleaner their link", m:"5 min", html:`<p>In the Cleaner kit, copy the "Welcome a new cleaner" message. It already includes their checklist link. Send the onboarding guide with it.</p><div class="btn-row"><button class="btn-ghost" type="button" data-goto="cleaner">Open the Cleaner kit</button></div>`},
    {id:"sched", t:"Load 5 routine messages into your scheduled messages", m:"10 min", html:`<p>Let the platform send the routine ones on time, and use Host HQ for everything else. Copy each message below from the Messages tab, then paste it into Airbnb (Menu, Messages, Scheduled messages) or VRBO's scheduled messages:</p><ul><li>Booking confirmed: right after booking</li><li>3 days before arrival</li><li>Check-in day instructions: morning of arrival</li><li>Checkout reminder: evening before checkout</li><li>Thank you and review request: within 24 hours of checkout</li></ul><p>Replace [Guest name] with the platform's guest first name shortcode, and the door code with the platform's door code field or shortcode, so every guest gets the right one.</p>`},
    {id:"sheets", t:"Make your copies of the two Google Sheets", m:"5 min", html:`<p>Open each link below and click "Make a copy". Your copy is private to you.</p>`},
    {id:"backup", t:"Add your backup person", m:"2 min", html:`<p>In your Turnover Command Center, add a backup cleaner and a local backup person who can let a guest in. The lockout and cleaner no-show playbooks depend on them.</p>`},
    {id:"book", t:"Start your Welcome Book", m:"Later", html:`<p>Open the Canva template, click "Use template", and add your photos and house details. Share it with guests as a link or print it for the home.</p>`}
  ];
  let setupDone = store.get("hqp_setup", {});
  function renderStart(){
    const done = SETUP.filter(s => setupDone[s.id]).length;
    $("#view-start").innerHTML = `
      <div class="lede"><h2>Welcome to Host HQ.</h2><p>Thirty minutes of setup, then everything is ready for your next guest. Tick each step as you go.</p></div>
      <div class="setup-prog">${done} of ${SETUP.length} setup steps done</div>
      <ul class="setup">${SETUP.map(s => `
        <li class="${setupDone[s.id] ? "done" : ""}"><input type="checkbox" data-setup="${s.id}" ${setupDone[s.id] ? "checked" : ""} aria-label="${esc(s.t)} done">
          <div><b>${esc(s.t)}<span class="t">${esc(s.m)}</span></b>${s.html}</div></li>`).join("")}
      </ul>
      <h3 class="section-title">Your files</h3>
      <div class="files">${FILES.map(f => { const l = fileLink(f.k); return `
        <div class="file"><span class="fmt">${f.fmt}</span><b>${f.name}</b><p>${f.d}</p>
          ${l ? `<a class="copy" href="${esc(l)}" target="_blank" rel="noopener">Open</a>` : `<span class="copy" aria-disabled="true">Link coming soon</span>`}</div>`; }).join("")}
      </div>
      <div class="panel"><h3>Need help?</h3><p>Email support@staysmithco.com. A real person replies within 24 hours.</p></div>`;
  }
  function onSetup(e){
    const c = e.target.closest("[data-setup]"); if(!c) return;
    setupDone[c.dataset.setup] = c.checked; store.set("hqp_setup", setupDone); renderStart();
  }

  const STAGES = ["All","Booking","Before arrival","Check-in","During stay","Checkout","After stay","Tough moments"];
  let stage = "All", query = "";
  function renderChips(){
    $("#chips").innerHTML = STAGES.map(s => {
      const n = s==="All" ? D.MESSAGES.length : D.MESSAGES.filter(m=>m.stage===s).length;
      return `<button class="chip" type="button" aria-pressed="${s===stage}" data-stage="${esc(s)}">${esc(s)}<span class="n">${n}</span></button>`;
    }).join("");
  }
  function blanks(body){ return (body.match(/\[[^\]]+\]/g)||[]).length; }
  function renderMessages(){
    $("#sampleNote").hidden = !isSample();
    const q = query.trim().toLowerCase();
    const list = D.MESSAGES.map((m,i)=>({m,i})).filter(({m}) =>
      (stage==="All" || m.stage===stage) &&
      (!q || (m.title+" "+m.body+" "+m.stage+" "+m.tip).toLowerCase().includes(q)));
    $("#msgList").innerHTML = list.length ? list.map(({m,i}) => { const b = blanks(m.body); return `
      <article class="card" id="msg-${i}">
        <div class="card-head"><div><div class="stage ${m.stage==="Tough moments"?"tough":""}">${esc(m.stage)}</div><h3>${esc(m.title)}</h3></div></div>
        <div class="when">${ICON.clock}<span>${esc(m.when)}</span></div>
        <div class="msg">${fillHTML(m.body)}</div>
        ${m.tip ? `<div class="tip">${esc(m.tip)}</div>` : ""}
        <div class="card-foot"><span class="hint">${b} blank${b===1?"":"s"} to fill</span>
        <button class="copy" type="button" data-copy="${i}">${ICON.copy}<span>Copy</span></button></div>
      </article>`; }).join("") : `<div class="empty">No messages match. Try "check-in", "refund" or "review".</div>`;
  }
  function openMessage(title){ stage="All"; query=title; $("#search").value=title; renderChips(); renderMessages(); show("messages"); }

  function renderPlaybooks(){
    $("#pbList").innerHTML = D.PLAYBOOKS.map((p,i) => `
      <details class="pb" ${i===0?"open":""}>
        <summary><span class="sev ${p.sev}">${p.sev==="urgent"?"Urgent":"Same day"}</span>
          <div class="pb-title"><b>${esc(p.title)}</b><span>${esc(p.sub)}</span></div>${ICON.chev}</summary>
        <ol class="steps">${p.steps.map(s=>`<li><div><b>${esc(s[0])}${s[2]?`<span class="mins">by ${s[2]} min</span>`:""}</b><p>${esc(s[1])}</p></div></li>`).join("")}</ol>
        <button class="pb-link" type="button" data-script="${esc(p.script)}"><span>Message to send: ${esc(p.script)}</span><span aria-hidden="true">→</span></button>
      </details>`).join("");
  }

  const allItems = [];
  D.ROOMS.forEach((r,ri) => r.items.forEach((it,ii) => allItems.push({id:ri+"-"+ii, room:r.name, text:it[0], photo:it[2]})));
  const ckey = () => CLEANER ? "hqc_checks_" + cleanerProp : "hqp_checks_" + (P.id || "sample");
  let checks = {};
  function renderCleaner(){
    checks = store.get(ckey(), {});
    const host = `
      <div class="lede"><h2>Cleaner kit.</h2><p>Everything your cleaner needs: their own checklist link, an onboarding guide, ready-to-send messages and an issue report.</p></div>
      <div class="panel"><h3>Your cleaner's checklist link</h3>
        <p>Send this link to your cleaner. It opens only the checklist below, on their phone, with no account. It's set for <b>${esc(P.property || "your property")}</b>${isSample() ? " (sample)" : ""}.</p>
        <div class="mono-link" id="cleanerLink">${esc(cleanerLink())}</div>
        <div class="btn-row" style="margin-top:10px"><button class="copy" type="button" id="copyCleanerLink">${ICON.copy}<span>Copy link</span></button>
          <button class="btn-ghost" type="button" data-copy-cmsg="0">Copy welcome message</button></div>
      </div>
      <h3 class="section-title">Messages for your cleaner</h3>
      <div class="list">${D.CLEANER_MSGS.map((m,i) => `
        <article class="card"><div class="card-head"><div><div class="stage">Cleaner</div><h3>${esc(m.title)}</h3></div></div>
          <div class="when">${ICON.clock}<span>${esc(m.when)}</span></div>
          <div class="msg">${fillHTML(m.body)}</div>
          <div class="card-foot"><span class="hint"></span><button class="copy" type="button" data-copy-cmsg="${i}">${ICON.copy}<span>Copy</span></button></div></article>`).join("")}</div>
      <h3 class="section-title">Cleaner onboarding guide</h3>
      <p class="section-sub">Send it with the welcome message, or walk through it together on the first turnover.</p>
      <div class="list">${D.GUIDE.map(g => `<details class="acc"><summary>${esc(g[0])}${ICON.chev}</summary><div class="acc-body">${g[1]}</div></details>`).join("")}</div>
      <div class="btn-row"><button class="btn-ghost" type="button" id="copyGuide">${ICON.copy} Copy the guide as text</button></div>
      <h3 class="section-title">The checklist your cleaner sees</h3>
      <p class="section-sub">You can also use it yourself. Ticks are saved separately for each property on this device.</p>`;
    $("#view-cleaner").innerHTML = (CLEANER ? `
      <div class="lede"><h2>Photo-proof turnover.</h2><p>Tick each item as you finish it, room by room, and take the marked photos. When you're done, copy the report and send it to the host with the photos.</p></div>` : host) + `
      <div class="progress-card">
        <div class="prog-row"><div class="big" id="pct">0%<small id="pctSub"></small></div>
          <span class="photo">${ICON.cam}<span id="photoCount"></span></span></div>
        <div class="bar"><i id="barFill"></i></div>
        <div class="meta-grid">
          <div class="field"><label for="cleanerName">Cleaner name</label><input id="cleanerName" placeholder="e.g. Maria"></div>
          <div class="field"><label for="cleanDate">Turnover date</label><input id="cleanDate" type="date"></div>
        </div>
      </div>
      <div class="list" id="rooms">${D.ROOMS.map((r,ri) => `
        <section class="room"><div class="room-head"><h3>${esc(r.name)}</h3><span class="count" data-count="${ri}"></span></div>
          <ul class="items">${r.items.map((it,ii)=>{ const id=ri+"-"+ii; return `
            <li class="item"><label for="c-${id}"><input type="checkbox" id="c-${id}" data-id="${id}" ${checks[id]?"checked":""}>
              <span class="item-text">${esc(it[0])}${it[1]?`<span>${esc(it[1])}</span>`:""}</span>
              ${it[2]?`<span class="photo">${ICON.cam}Photo</span>`:"<span></span>"}</label></li>`;}).join("")}</ul></section>`).join("")}</div>
      <div class="progress-card">
        <div class="field"><label for="issues">Running low or anything to tell the host</label><textarea id="issues" placeholder="e.g. Only 1 roll of toilet paper left. Coffee almost out."></textarea></div>
        <div class="actions"><button class="copy" id="copyReport" type="button">${ICON.copy}<span>Copy turnover report</span></button>
          <button class="btn-ghost" id="resetList" type="button">Start new turnover</button></div>
        <div class="hint">Paste the report into your text thread with the host, then send the photos in the same thread.</div>
      </div>
      <h3 class="section-title">Damage or issue report</h3>
      <p class="section-sub">For anything broken, damaged, missing or left behind. Photograph it before you clean or move it.</p>
      <div class="panel"><div class="report-grid">
        <div class="field"><label for="rType">Type</label><select id="rType"><option>Damage</option><option>Something broken</option><option>Missing item</option><option>Item left by guest</option><option>Pests</option><option>Other</option></select></div>
        <div class="field"><label for="rRoom">Room</label><select id="rRoom">${D.ROOMS.filter(r=>!["Arrival","Restock","Final check"].includes(r.name)).map(r=>`<option>${esc(r.name)}</option>`).join("")}<option>Outside</option><option>Other</option></select></div>
        <div class="field" style="grid-column:1/-1"><label for="rDesc">What did you find?</label><textarea id="rDesc" placeholder="e.g. Red wine stain on the living room rug, about the size of a hand."></textarea></div>
        <label class="check-inline"><input type="checkbox" id="rPhoto"> Photo taken</label>
        <label class="check-inline"><input type="checkbox" id="rUrgent"> Needs fixing before the next guest</label>
      </div>
      <div class="btn-row" style="margin-top:12px"><button class="copy" type="button" id="copyIssue">${ICON.copy}<span>Copy issue report</span></button></div></div>`;

    const cn=$("#cleanerName"), cd=$("#cleanDate"), is=$("#issues");
    const pfx = CLEANER ? "hqc_" : "hqp_";
    cn.value = store.get(pfx+"cleaner",""); is.value = store.get(ckey()+"_notes","");
    cd.value = store.get(ckey()+"_date", new Date().toISOString().slice(0,10));
    cn.addEventListener("input", ()=>store.set(pfx+"cleaner", cn.value));
    cd.addEventListener("input", ()=>store.set(ckey()+"_date", cd.value));
    is.addEventListener("input", ()=>store.set(ckey()+"_notes", is.value));
    updateProgress();
  }
  function updateProgress(){
    const total = allItems.length, done = allItems.filter(i=>checks[i.id]).length;
    const photos = allItems.filter(i=>i.photo), pd = photos.filter(i=>checks[i.id]).length;
    const pct = Math.round(done/total*100);
    $("#pct").firstChild.nodeValue = pct + "%";
    $("#pctSub").textContent = done + " of " + total + " tasks";
    $("#photoCount").textContent = pd + " of " + photos.length + " photos";
    $("#barFill").style.width = pct + "%";
    D.ROOMS.forEach((r,ri) => {
      const ids = r.items.map((_,ii)=>ri+"-"+ii), d = ids.filter(id=>checks[id]).length;
      const el = document.querySelector('[data-count="'+ri+'"]'); el.textContent = d + "/" + ids.length; el.classList.toggle("full", d===ids.length);
    });
  }
  let resetArmed=false, resetT;
  function onCleanerClick(e){
    const t = e.target;
    if(t.closest("#copyCleanerLink")) return copyText(cleanerLink(), t.closest("button"), "Cleaner link copied. Send it to your cleaner.");
    const cm = t.closest("[data-copy-cmsg]"); if(cm) return copyText(fillText(D.CLEANER_MSGS[+cm.dataset.copyCmsg].body), cm, "Copied. Paste it into your text with your cleaner.");
    if(t.closest("#copyGuide")){
      const txt = "CLEANER GUIDE: " + (P.property||"") + "\n\n" + D.GUIDE.map(g => g[0].toUpperCase() + "\n" + g[1].replace(/<li>/g,"- ").replace(/<[^>]+>/g,"\n").replace(/\n{2,}/g,"\n").trim()).join("\n\n");
      return copyText(txt, t.closest("button"), "Guide copied. Paste it into your text with your cleaner.");
    }
    if(t.closest("#copyReport")){
      const name = CLEANER ? cleanerProp : P.property;
      const done = allItems.filter(i=>checks[i.id]), missing = allItems.filter(i=>!checks[i.id]), photos = allItems.filter(i=>i.photo);
      let r = "TURNOVER REPORT: " + (name || "Property") + "\n";
      r += "Date: " + ($("#cleanDate").value || "-") + " | Cleaner: " + ($("#cleanerName").value || "-") + "\n";
      r += "Completed: " + done.length + " of " + allItems.length + " tasks\n";
      r += "Photos taken: " + photos.filter(i=>checks[i.id]).length + " of " + photos.length + "\n";
      r += missing.length ? "\nNOT DONE:\n" + missing.map(i=>"- " + i.room + ": " + i.text).join("\n") + "\n" : "\nAll tasks complete.\n";
      r += "\nNOTES / LOW SUPPLIES:\n" + ($("#issues").value.trim() || "None reported.");
      return copyText(r, t.closest("button"), "Report copied. Paste it into your text with the host.");
    }
    if(t.closest("#copyIssue")){
      const name = CLEANER ? cleanerProp : P.property;
      let r = "ISSUE REPORT: " + (name || "Property") + "\n";
      r += "Date: " + ($("#cleanDate").value || "-") + " | Reported by: " + ($("#cleanerName").value || "-") + "\n";
      r += "Type: " + $("#rType").value + " | Room: " + $("#rRoom").value + "\n";
      r += "What: " + ($("#rDesc").value.trim() || "-") + "\n";
      r += "Photo taken: " + ($("#rPhoto").checked ? "Yes" : "No") + " | Needs fixing before next guest: " + ($("#rUrgent").checked ? "YES" : "No");
      return copyText(r, t.closest("button"), "Issue report copied. Send it with the photo.");
    }
    if(t.closest("#resetList")){
      const b = t.closest("button");
      if(!resetArmed){ resetArmed=true; b.textContent="Tap again to clear all ticks"; b.classList.add("confirm");
        resetT=setTimeout(()=>{ resetArmed=false; b.textContent="Start new turnover"; b.classList.remove("confirm"); },3500); return; }
      clearTimeout(resetT); resetArmed=false; checks={}; store.set(ckey(), checks);
      store.set(ckey()+"_notes",""); store.set(ckey()+"_date", new Date().toISOString().slice(0,10));
      renderCleaner(); toast("Checklist cleared for the next turnover.");
    }
  }
  function onCleanerChange(e){
    const c = e.target.closest("input[data-id]"); if(!c) return;
    checks[c.dataset.id] = c.checked; store.set(ckey(), checks); updateProgress();
  }

  function renderReviews(){
    $("#view-reviews").innerHTML = `
      <div class="lede"><h2>The review engine.</h2><p>The messages and timing for asking every guest for an honest review, and for catching problems before they reach one.</p></div>
      <div class="panel"><ol class="timeline">${D.REVIEW_STEPS.map(s => `
        <li><div><span class="w">${esc(s.w)}</span><b>${esc(s.t)}</b><p>${esc(s.d)}</p>
          ${s.msgs.map(m => `<button class="link-btn" type="button" data-script="${esc(m)}">Open: ${esc(m)} →</button>`).join("")}</div></li>`).join("")}</ol></div>
      <div class="panel"><h3>Rules that protect your reviews</h3><ul class="rules">
        <li>Ask for an honest review, never for a specific star rating.</li>
        <li>Never offer a refund, discount or gift in exchange for a review, or to change one.</li>
        <li>Keep every complaint, refund and payment inside the platform thread.</li>
        <li>Reply to every review within 3 days. Future guests read your replies.</li>
        <li>Never argue in public replies or share personal details about a guest.</li></ul></div>`;
  }

  function renderPrompts(){
    $("#view-prompts").innerHTML = `
      <div class="lede"><h2>Listing optimizer prompts.</h2><p>Paste these into ChatGPT, Claude or Gemini. Your property details are filled in; replace the highlighted brackets first. Always check the result before you publish it.</p></div>
      <div class="list">${D.PROMPTS.map((p,i) => `
        <article class="card"><div class="card-head"><div><div class="stage">AI prompt</div><h3>${esc(p.title)}</h3></div></div>
          <div class="when"><span>${esc(p.use)}</span></div>
          <div class="msg">${fillHTML(p.text)}</div>
          <div class="card-foot"><span class="hint">${blanks(p.text)} brackets to fill</span><button class="copy" type="button" data-copy-prompt="${i}">${ICON.copy}<span>Copy</span></button></div></article>`).join("")}</div>`;
  }

  let editing = null;
  function renderProperties(){
    const list = props.list;
    $("#view-properties").innerHTML = `
      <div class="lede"><h2>My properties</h2><p>Enter each listing once. Details fill every message and prompt, and stay saved in this browser on this device only. Nothing is sent anywhere.</p></div>
      ${list.length ? `<div class="prop-list">${list.map(p => `
        <div class="prop-card ${p.id===P.id?"active":""}"><div><b>${esc(p.property || "Untitled property")}</b><span>${esc(p.address || "")}</span>${p.id===P.id?`<div class="tag">In use</div>`:""}</div>
          <div class="btn-row">${p.id!==P.id?`<button class="btn-ghost" type="button" data-use="${esc(p.id)}">Use</button>`:""}<button class="btn-ghost" type="button" data-edit="${esc(p.id)}">Edit</button></div></div>`).join("")}</div>`
        : `<div class="sample-note"><span class="dot"></span><div>No properties yet. Messages are showing a sample property until you add yours.</div></div>`}
      ${list.length < MAX_PROPS ? `<div class="btn-row"><button class="copy" type="button" id="addProp">+ Add a property</button><span class="hint">${list.length} of ${MAX_PROPS}</span></div>` : `<div class="hint">You've added the maximum of ${MAX_PROPS} properties.</div>`}
      <form class="form" id="propForm" autocomplete="off" hidden></form>
      <div class="hint">Door codes are never stored here. Messages leave a <span class="ph">[door code]</span> blank so each guest gets the right code.</div>`;
    if(editing !== null) openForm(editing === "__new" ? null : editing);
  }
  function openForm(id){
    editing = id || "__new";
    const f = $("#propForm"); if(!f) return;
    const p = id ? props.list.find(x => x.id === id) : {};
    f.hidden = false;
    f.innerHTML = `<h3>${id ? "Edit property" : "Add a property"}</h3>` + FIELDS.map(([k,l,ph,wide]) => `
      <div class="field ${wide?"wide":""}"><label for="f-${k}">${l}</label><input id="f-${k}" name="${k}" placeholder="${esc(ph)}" value="${esc(p[k]||"")}" ${k==="property"?"required":""}></div>`).join("") + `
      <div class="wide actions" style="align-items:center"><button class="copy" type="submit"><span>Save property</span></button>
        <button class="btn-ghost" type="button" id="cancelForm">Cancel</button>
        ${id ? `<button class="btn-ghost" type="button" id="deleteProp" data-id="${esc(id)}">Delete</button>` : ""}</div>`;
    f.scrollIntoView({behavior:"smooth", block:"start"});
  }
  let delArmed = false;
  function onPropsClick(e){
    const t = e.target;
    if(t.closest("#addProp")) return openForm(null);
    const ed = t.closest("[data-edit]"); if(ed) return openForm(ed.dataset.edit);
    const us = t.closest("[data-use]"); if(us){ props.active = us.dataset.use; saveProps(); editing=null; refreshAll(); toast("Now using " + (P.property||"this property") + "."); return; }
    if(t.closest("#cancelForm")){ editing=null; renderProperties(); return; }
    const del = t.closest("#deleteProp");
    if(del){
      if(!delArmed){ delArmed=true; del.textContent="Tap again to delete"; del.classList.add("confirm"); setTimeout(()=>{delArmed=false; if(del.isConnected){del.textContent="Delete"; del.classList.remove("confirm");}},3500); return; }
      delArmed=false; props.list = props.list.filter(p => p.id !== del.dataset.id);
      if(props.active === del.dataset.id) props.active = props.list[0] ? props.list[0].id : null;
      saveProps(); editing=null; refreshAll(); toast("Property deleted.");
    }
  }
  function onPropSubmit(e){
    if(e.target.id !== "propForm") return;
    e.preventDefault();
    const f = e.target, data = {};
    FIELDS.forEach(([k]) => data[k] = (f.elements[k].value || "").trim());
    if(!data.property){ toast("Add a listing name first."); return; }
    if(editing && editing !== "__new"){ const p = props.list.find(x => x.id === editing); Object.assign(p, data); props.active = p.id; }
    else { data.id = "p" + Date.now().toString(36); props.list.push(data); props.active = data.id; }
    saveProps(); editing = null; refreshAll();
    setupDone.prop = true; store.set("hqp_setup", setupDone); renderStart();
    toast("Saved. Every message now uses " + data.property + ".");
  }

  function refreshAll(){
    if(CLEANER){ renderCleaner(); return; }
    renderSelect(); renderStart(); renderChips(); renderMessages(); renderPlaybooks(); renderCleaner(); renderReviews(); renderPrompts(); renderProperties();
  }
  if(!CLEANER){
    $("#propSelect").addEventListener("change", onSelect);
    $("#view-start").addEventListener("change", onSetup);
    $("#chips").addEventListener("click", e => { const c=e.target.closest(".chip"); if(!c) return; stage=c.dataset.stage; renderChips(); renderMessages(); });
    $("#search").addEventListener("input", e => { query = e.target.value; renderMessages(); });
    $("#msgList").addEventListener("click", e => { const b=e.target.closest("[data-copy]"); if(!b) return; copyText(fillText(D.MESSAGES[+b.dataset.copy].body), b); });
    document.addEventListener("click", e => { const b=e.target.closest("[data-script]"); if(b) openMessage(b.dataset.script); });
    $("#view-prompts").addEventListener("click", e => { const b=e.target.closest("[data-copy-prompt]"); if(b) copyText(fillText(D.PROMPTS[+b.dataset.copyPrompt].text), b, "Prompt copied. Paste it into your AI assistant."); });
    $("#view-properties").addEventListener("click", onPropsClick);
    $("#view-properties").addEventListener("submit", onPropSubmit);
  }
  $("#view-cleaner").addEventListener("click", onCleanerClick);
  $("#view-cleaner").addEventListener("change", onCleanerChange);
  refreshAll();
  if(!CLEANER){
    const h = (location.hash || "").replace("#","");
    show(VIEWS.includes(h) ? h : (isSample() ? "start" : "messages"));
  }
})();
